import { useContext } from 'react'
import { DropzoneVariant } from '~/components/shared/componentStyles/Dropzone.style'

import ContentAcceptedMulti from './ContentAcceptedMulti'
import ContentAcceptedSingle from './ContentAcceptedSingle'
import ContentDefault from './ContentDefault'
import ContentDragAccepted from './ContentDragAccepted'
import ContentError from './ContentError'
import { Context } from './Context'

export default function Content() {
  const {
    currentVariant,
    props: { allowMultiple },
  } = useContext(Context)

  switch (currentVariant) {
    case DropzoneVariant.DragAccepted: {
      return <ContentDragAccepted />
    }
    case DropzoneVariant.FileAccepted: {
      return allowMultiple ? (
        <ContentAcceptedMulti />
      ) : (
        <ContentAcceptedSingle />
      )
    }
    case DropzoneVariant.Error: {
      return <ContentError />
    }
    case DropzoneVariant.Default:
    case DropzoneVariant.Active:
    default: {
      return <ContentDefault />
    }
  }
}
